import Vue from 'vue'
import VueRouter from 'vue-router'
import Product from '../views/Product.vue'
import Cart from '../views/Cart.vue'
import Confirmation from '../views/Confirmation.vue'
import Payload from '../views/Payload.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Product',
    component: Product
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart
  },
  {
    path: '/confirmation',
    name: 'Confirmation',
    component: Confirmation
  },
  {
    path: '/payload',
    name: 'Payload',
    component: Payload
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    window.scrollTo(0,0);
  }
})

export default router
